import { queryOptions, useQuery } from '@tanstack/react-query';

import { dictionaryApi } from '../api/dictionary-api';

import { dictionaryKeys } from './dictionary-keys';

export function productTypesQueryOptions() {
  return queryOptions({
    queryKey: dictionaryKeys.productTypes(),
    queryFn: dictionaryApi.listProductTypes,
    staleTime: 5 * 60_000,
  });
}

export function useProductTypes() {
  return useQuery(productTypesQueryOptions());
}

export function productTypeQueryOptions(id: string) {
  return queryOptions({
    queryKey: dictionaryKeys.productType(id),
    queryFn: () => dictionaryApi.getProductType(id),
    staleTime: 5 * 60_000,
  });
}

/** Detail carries the attribute assignments (required flags, order); `enabled` gates on a chosen type. */
export function useProductType(id: string | null | undefined) {
  return useQuery({ ...productTypeQueryOptions(id ?? ''), enabled: Boolean(id) });
}
